<template>
  <div class="background">
  <div class="chart-container">
    <div v-html="styleText"></div>
    <div @click="printPdf" class="noPrint">{{$t('print')}}</div>
    <div class="Hcp-main-header">
      <div class="main-header-left">
        <img src="../../assets/LOGO.png">
      </div>
      <div class="main-header-right">
        <p>{{$t('TrendRe')}}</p>
        <p style="font-size: 9px;">{{$t('period')}}: {{timeRange}}</p>
      </div>
    </div>
    <table class="status-table1" :class="{'zh1':!isEn,'de1':isDe||isIt}">
      <tr>
        <td class="td1 td2">{{$t('uername')}}</td><td colspan="4" class="td2">{{statics.username}}</td>
        <td class="td1 td2">{{$t('fullName')}}</td><td colspan="4" class="td3">{{statics.name}}</td>
      </tr>
      <tr>
        <td rowspan="3" class="td1 td2">{{$t('devices')}}</td>
        <td class="td2" id="reportPdmTitle">{{$t('pdm')}}</td><td colspan="8" class="td3">{{devices[0]}}</td>
      </tr>
      <tr><td class="td2">{{$t('tran')}}</td><td colspan="8" class="td3">{{devices[1]}}</td></tr>
      <tr><td class="td2">{{$t('pumpBase')}}</td><td colspan="8" class="td3">{{devices[2]}}</td></tr>
      <tr>
        <td class="td1 td4">{{$t('disType')}}</td><td colspan="4" class="td4">{{statics.medical_history}}</td>
        <td class="td td4">{{$t('HbA1c')}}</td><td colspan="4">{{hb1c[0]}}</td>
      </tr>
    </table>

    <div class="small-hr"></div>
    <el-row>
      <el-col :span="24">
        <div id="chart4_1" class="graph"></div>
      </el-col>
    </el-row>
    <div class="statics">
      <p>{{$t('static')}}</p>
      <table class="statics-table" :class="{'de2':isDe||isIt}">
        <tr>
          <td rowspan="2" width="9%" class="td1">{{$t('static')}}</td>
          <td colspan="10" width="29%" class="td1">{{$t('Basics')}}</td>
          <td colspan="3"  class="td1">{{$t('distri')}}%</td>
          <td colspan="4" width="20%"  class="td1">{{$t('stab')}}</td>
          <td colspan="7" class="td2">{{$t('BG1')}}</td>
        </tr>
        <tr>
          <td class="td2">{{$t('Avg')}}</td> <td class="td2">{{$t('max')}}</td> <td class="td2">{{$t('min')}}</td> <td class="td2">{{$t('Med')}}</td>
          <td class="td2">{{$t('Q1')}}</td><td class="td2">{{$t('Q3')}}</td> <td class="td2">{{$t('IQR')}}</td><td class="td2">{{$t('SD')}}</td>
          <td  class="td2">{{$t('CV')}}</td> <td class="td1">{{$t('SE1')}}</td><td class="td2">{{$t('high')}}</td> <td class="td2">{{$t('low')}}</td>
          <td class="td1">{{$t('target')}}</td><td class="td2">{{$t('aucAbove')}}</td><td class="td2">{{$t('aucBelow')}}</td>
          <td class="td2">{{$t('#high')}}</td><td class="td1">{{$t('#low')}}</td><td class="td2">{{$t('high')}}%</td>
          <td class="td2">{{$t('low')}}%</td><td class="td1">{{$t('target')}}%</td>
          <td class="td2">{{$t('Avg')}}</td> <td class="td2">{{$t('SD')}}</td><td class="td2">{{$t('#hypo')}}</td><td class="td2">{{$t('bgRead')}}</td>
        </tr>
        <tr v-for="(day,j) in xDate2">
          <td class="td1">{{day}}</td>
          <td class="td2">{{glucose[j].sg_avg}}</td><td class="td2">{{glucose[j].sg_max}}</td><td class="td2">{{glucose[j].sg_min}}</td><td class="td2">{{glucose[j].sg_median}}</td>
          <td class="td2">{{glucose[j].sg_q1}}</td><td class="td2">{{glucose[j].sg_q3}}</td><td class="td2">{{glucose[j].sg_iqr}}</td><td class="td2">{{glucose[j].sg_sd}}</td>
          <td class="td2">{{glucose[j].sg_cv}}</td><td class="td1">{{glucose[j].sg_se}}</td>
          <td class="td2">{{glucose[j].sg_up}}</td>  <td class="td2">{{glucose[j].sg_lp}}</td><td class="td1">{{glucose[j].sg_tp}}</td>
          <td class="td2">{{glucose[j].sg_aucu}}</td><td class="td2">{{glucose[j].sg_aucl}}</td><td class="td2">{{glucose[j].sg_nu}}</td><td class="td1">{{glucose[j].sg_nl}}</td>
          <td class="td2">{{glucose[j].bg_up}}</td><td class="td2">{{glucose[j].bg_lp}}</td><td class="td1">{{glucose[j].bg_tp}}</td>
          <td class="td2">{{glucose[j].bg_avg}}</td><td class="td2">{{glucose[j].bg_sd}}</td><td class="td2">{{glucose[j].bg_hypo_num}}</td><td class="td2">{{glucose[j].bg_num}}</td>
        </tr>
        <tr>
          <td class="td3">{{$t('Avg/Total')}}</td>
          <td>{{glucose[dayNum].sg_avg}}</td><td>{{glucose[dayNum].sg_max}}</td><td>{{glucose[dayNum].sg_min}}</td><td>{{glucose[dayNum].sg_median}}</td>
          <td>{{glucose[dayNum].sg_q1}}</td><td>{{glucose[dayNum].sg_q3}}</td><td>{{glucose[dayNum].sg_iqr}}</td><td>{{glucose[dayNum].sg_sd}}</td>
          <td>{{glucose[dayNum].sg_cv}}</td><td class="td3">{{glucose[dayNum].sg_se}}</td>
          <td>{{glucose[dayNum].sg_up}}</td><td>{{glucose[dayNum].sg_lp}}</td><td class="td3">{{glucose[dayNum].sg_tp}}</td>
          <td>{{glucose[dayNum].sg_aucu}}</td><td>{{glucose[dayNum].sg_aucl}}</td><td>{{glucose[dayNum].sg_nu}}</td><td class="td3">{{glucose[dayNum].sg_nl}}</td>
          <td>{{glucose[dayNum].bg_up}}</td><td>{{glucose[dayNum].bg_lp}}</td><td class="td3">{{glucose[dayNum].bg_tp}}</td>
          <td>{{glucose[dayNum].bg_avg}}</td><td>{{glucose[dayNum].bg_sd}}</td><td>{{glucose[dayNum].bg_hypo_num}}</td><td>{{glucose[dayNum].bg_num}}</td>
        </tr>
      </table>
    </div>

    <div class="page-seperator"></div>
    <div class="page-starter"><!--<br/><br/><br/><br/><br/><br/><br/><br/><br/>-->
    </div>

    <el-row>
      <el-col :span="24">
        <div id="chart4_2" class="graph"></div>
      </el-col>
    </el-row>
    <div class="statics spe-statics">
      <p>{{$t('static')}}</p>
      <table class="statics-table" :class="{'de2':isDe}">
        <tr>
          <td rowspan="2" width="11%" class="td1">{{$t('static')}}</td>
          <td colspan="5"  class="td1">{{$t('insulin')}}</td>
          <td colspan="2"  class="td1">{{$t('carbs')}}</td>
          <td colspan="2" class="td2">{{$t('exercise')}}</td>
        </tr>

        <tr>
          <td class="td1">{{$t('total')}} {{$t('ins_unit')}}</td> <td class="td1">{{$t('avg_daily_basal')}}</td> <td class="td1">{{$t('avg_daily_bolus')}}</td> <td class="td1">{{$t('ofBolus')}}</td> <td class="td1">{{$t('avgBolus')}}</td>
          <td class="td1">{{$t('carbs')}} (g)</td> <td class="td1">{{$t('ofMeal')}}</td><td class="td1">{{$t('Dura1')}}</td><td  class="td2">{{$t('ofExer')}}</td>
        </tr>
        <tr v-for="(day,i) in xDate2">
          <td class="td1">{{day}}</td>
          <td class="td1">{{event[i].ins_total}}</td>
          <td class="td1">
            <span class="value_percent_cell left_value">{{event[i].ins_basal}}</span>
            <span class="value_percent_cell right_percent">{{event[i].ins_basal_p}}</span>
          </td>
          <td class="td1">
            <span class="value_percent_cell left_value">{{event[i].ins_bolus}}</span>
            <span class="value_percent_cell right_percent">{{event[i].ins_bolus_p}}</span>
          </td>
          <td class="td1">{{event[i].ins_bolus_n}}</td>
          <td class="td1">{{event[i].ins_bolus_avg}}</td><td class="td1">{{event[i].carb_gram}}</td><td class="td1">{{event[i].carb_num}}</td>
          <td class="td1">{{event[i].exer_time}}</td><td class="td2">{{event[i].exer_num}}</td>
        </tr>
        <tr>
          <td class="td3">{{$t('Avg/Total')}}</td>
          <td class="td3">{{event[dayNum].ins_total}}</td>
          <td class="td3">
            <span class="value_percent_cell left_value">{{event[dayNum].ins_basal}}</span>
            <span class="value_percent_cell right_percent">{{event[dayNum].ins_basal_p}}</span>
          </td>
          <td class="td3">
            <span class="value_percent_cell left_value">{{event[dayNum].ins_bolus}}</span>
            <span class="value_percent_cell right_percent">{{event[dayNum].ins_bolus_p}}</span>
          </td>
          <td class="td3">{{event[dayNum].ins_bolus_n}}</td><td class="td3">{{event[dayNum].ins_bolus_avg}}</td><td class="td3">{{event[dayNum].carb_gram}}</td>
          <td class="td3">{{event[dayNum].carb_num}}</td><td class="td3">{{event[dayNum].exer_time}}</td><td>{{event[dayNum].exer_num}}</td>
        </tr>
        <!--
        <tr>
          <td class="td1">{{$t('total')}}</td> <td class="td1">{{$t('basal')}}%</td> <td class="td1">{{$t('bolus')}}%</td> <td class="td1">{{$t('ofBolus')}}</td> <td class="td1">{{$t('avgBolus')}}</td>
          <td class="td1">{{$t('carbs')}}(g)</td> <td class="td1">{{$t('ofMeal')}}</td><td class="td1">{{$t('Dura1')}}</td><td  class="td2">{{$t('ofExer')}}</td>
        </tr>
        <tr v-for="(day,i) in xDate2">
          <td class="td1">{{day}}</td>
          <td class="td1">{{event[i].ins_total}}</td><td class="td1">{{event[i].ins_basal_p}}</td><td class="td1">{{event[i].ins_bolus_p}}</td><td class="td1">{{event[i].ins_bolus_n}}</td>
          <td class="td1">{{event[i].ins_bolus_avg}}</td><td class="td1">{{event[i].carb_gram}}</td><td class="td1">{{event[i].carb_num}}</td>
          <td class="td1">{{event[i].exer_time}}</td><td class="td2">{{event[i].exer_num}}</td>
        </tr>
        <tr>
          <td class="td3">{{$t('Avg/Total')}}</td>
          <td class="td3">{{event[dayNum].ins_total}}</td><td class="td3">{{event[dayNum].ins_basal_p}}</td><td class="td3">{{event[dayNum].ins_bolus_p}}</td>
          <td class="td3">{{event[dayNum].ins_bolus_n}}</td><td class="td3">{{event[dayNum].ins_bolus_avg}}</td><td class="td3">{{event[dayNum].carb_gram}}</td>
          <td class="td3">{{event[dayNum].carb_num}}</td><td class="td3">{{event[dayNum].exer_time}}</td><td>{{event[dayNum].exer_num}}</td>
        </tr>-->
      </table>
    </div>
    <div class="page-end"></div>
  </div>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import auth from '../../auth/auth'
      import format from '@/lib/format'
  import B64 from '../../auth/base64'
  import dataTool from '../../auth/dataTool'
  export default{
    data() {
      return {
        statics:{},devices:['--','--','--'],hb1c:['--'],isMg:'',interval:'',ts:[],isDe:false,
        styleText:'<style type="text/css" media="print">@page{size:landscape;margin:0;}</style>',
        glucose: [
          {
            "bg_avg": '--',
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
        ],
        event:[
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
        ],

        TaData1:[],TaData2:[],TaData3:[],xDate:[],xDate2:[],sgMax:20,value2:'',value1:'',dayNum:0,isEn:false,
        chartWidth: '', timer: false,typeChooseVisible:false,isC:false, flag:0,count:0, sta:'',end:'',Average:[],
        chart4_1: null,chart4_2: null,
        startDate:'',  timeRange:'',defaultDate:'',whichDay:' Everyday', weekmode:'yyyyyyy',isIt:false,
        uid:0,st:0,et:0,basalMax:25,bgMax:10,days:'',
        date:[true,true,true,true,true,true,true],
        pickerOptions:{
          disabledDate(time){
            return time.getTime()>Date.now();
          }
        },
        textStyle: {
          color: '#282828',
          fontWeight: 'normal',
          fontSize: '12',
          fontFamily: 'SFUIText-Regular'
        },
        titlePadding: [0, 0, 8, 33],
        grid: {x: '3.5%', y: '15%', width: '94%', height: '70%'},
        yAxisLabel: {interval: 0, margin: 5, textStyle: {color: '#282828', baseline: 'middle'}, showMinLabel: false},
        xLabel:['18-07-2017','19-07-2017','20-07-2017','21-07-2017','22-07-2017','23-07-2017','24-07-2017','25-07-2017',
          '26-07-2017','27-07-2017','28-07-2017','29-07-2017','30-07-2017','31-07-2017'],
      }
    },
    computed: {
      DataS(){
        return this.$store.state.DataS;
      },
    },
    methods: {
      drawChart4_1() {
        this.chart4_1 = echarts.init(document.getElementById('chart4_1'));
        this.chart4_1.setOption({
          title: {
            text: (this.isMg)? this.$t('sensorGlu')+' (mg/dL)':this.$t('sensorGlu')+' (mmol/L)',
            textStyle: this.textStyle,
            padding: this.titlePadding,
          },
          xAxis: [{
            data:this.xDate,
            axisLine: {lineStyle: {color: '#ccc'}},
            splitLine:{show:true,interval:0},
            // splitNumber:14,
            axisLabel:{margin: 15, interval:0,textStyle: {color: '#282828', baseline: 'middle'}},
          }],
          yAxis: [{
            type: 'value',
            min:0,max: (this.isMg)? 400:25,
            axisLabel: this.yAxisLabel,
            axisLine: {lineStyle: {color: '#ccc'}},
            boundaryGap: false,
            axisTick: {length: 0},
          }],
          grid: this.grid,
          series: [
            {
              type:'boxplot',
              data:this.TaData3[1],
              hoverAnimation:false,
              boxWidth:['10%','15%'],
              itemStyle: {normal: {borderColor:'#0095ff',},},
            },
            {
              name:'line3',
              type:'line',
              data:this.TaData3[0],
              itemStyle: {normal: {
                color:'transparent',
                borderColor:'#0095ff',
                borderWidth:1,
              }},
              lineStyle:{normal:{
                color:'#e89b00',
                width:1,
              }},
              symbol:'diamond',
              symbolSize:5,
            },
          ],
        });
      },
      drawChart4_2() {
        this.chart4_2 = echarts.init(document.getElementById('chart4_2'));
        this.chart4_2.setOption({
          title: {
            text: this.$t('insulin')+' '+this.$t('ins_unit'),
            textStyle: this.textStyle,
            padding: this.titlePadding,
          },
          xAxis: [
            {
              data:this.xDate,
              axisLine: {lineStyle: {color: '#ccc'}},
              splitLine:{show:true,interval:0},
              splitNumber:14,
              axisLabel:{
                margin: 15, interval:0,textStyle: {color: '#282828', baseline: 'middle'} ,
              },
            }],
          yAxis: [
            {
              type: 'value',
              min:0,max:this.basalMax,
              axisLabel: this.yAxisLabel,
              axisLine: {lineStyle: {color: '#ccc'}},
              boundaryGap: false,
              axisTick: {length: 0},
            }],
          grid: this.grid,
          legend:{
            itemWidth:11,
            itemHeight:11,
            right:35,
            data:[
              { name:this.$t('basal'),icon:'rect'},
              { name:this.$t('bolus'),icon:'rect'}
            ]
          },
          series: [
            {
              name:this.$t('basal'),
              type:'bar',
              data:this.TaData2[0],
              barWidth:'32%',
              itemStyle: {normal: {color:'#75e28a',}},
            },
            {
              name:this.$t('bolus'),
              type:'bar',
              data:this.TaData2[1],
              barWidth:'32%',
              itemStyle: {normal: {color:'#4e86f4',}},
            },
          ],
        });
      },
      drwCharts(){
        this.drawChart4_1();
        this.drawChart4_2();
      },
      chartsDispose(){
        this.chart4_1.dispose();
        this.chart4_2.dispose();
      },
      getStatics(param){
        this.$http.get('api/v2.1/report/'+this.uid+'/data/ta',{params:{param}}).then(function (res) {
          let err =res.body.error;
          if(err === 0){
            let data =  res.data.data;
            data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
            this.statics = data;
            this.devices = (data.devices)?data.devices:this.devices;
            if ('EasyPatch'==this.devices[0]) {
              document.getElementById('reportPdmTitle').innerHTML='APP';
            }
            this.hb1c = (data.hba1c)?data.hba1c:this.hb1c;
            this.glucose = (data.glucose_stat)?data.glucose_stat:this.glucose;
            this.glucose.map(function (e,i) {
              if(e.bg_up!=='--'){
                e.bg_up = e.bg_up.toFixed(1);
              }
              if(e.bg_tp!=='--'){
                e.bg_tp = e.bg_tp.toFixed(1);
              }
              if(e.bg_lp!=='--'){
                e.bg_lp = e.bg_lp.toFixed(1);
              }
            });
            this.dayNum = this.glucose.length-1;
            this.event = (data.insulin_and_event_stat)?data.insulin_and_event_stat:this.event;
          }
        },function(err){
          context.$message.error('Try again!');
        })
      },
      getTaReportInfo(report_data){
        //this.$http.get('api/v2.1/report/'+this.uid+'/data/ta',{params:{param}}).then(function (res) {
        //  let err =res.body.error;
        //  if(err === 0){
            //let data =  res.data.data;
            let data =  report_data;
            data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
            this.statics = data;
            this.devices = (data.devices)?data.devices:this.devices;
            this.hb1c = (data.hba1c)?data.hba1c:this.hb1c;
            this.glucose = (data.glucose_stat)?data.glucose_stat:this.glucose;
            this.glucose.map(function (e,i) {
              if(e.bg_up!=='--'){
                e.bg_up = e.bg_up.toFixed(1);
              }
              if(e.bg_tp!=='--'){
                e.bg_tp = e.bg_tp.toFixed(1);
              }
              if(e.bg_lp!=='--'){
                e.bg_lp = e.bg_lp.toFixed(1);
              }
            });
            this.dayNum = this.glucose.length-1;
            this.event = (data.insulin_and_event_stat)?data.insulin_and_event_stat:this.event;
        //  }
        //},function(err){
        //  context.$message.error('Try again!');
        //})
      },
      getTs2(context,st,et){
        let ts =[];  this.xDate=[];
        this.days =(et-st)/86400+1;
        let No = auth.chekcNoDate(context.weekmode);
        let star = format.formatterDate9(st);
        let starDate = new Date(star[0],star[1],star[2]);
        if(this.days<=7){
          let k=0;
          for(let i=0;i<this.days;i++){
            starDate = new Date(star[0],star[1],star[2]);
            let d =star[2]+i;
            let now = starDate.setDate(d);
            let day = new Date(now).getDay();
            if(No.indexOf(day)===-1){
              ts[k] = [];
              ts[k][0] =  new Date(now).getTime()/1000;
              //startDate每次setDate()都会改变自身，因此使用前初始化
              starDate = new Date(star[0],star[1],star[2]);
              ts[k][1] =  new Date(starDate.setDate(d+1)).getTime()/1000;
              this.xDate[k] = format.formatterDate4(ts[k][0]);
              k++;
            }
          }
          this.interval = 'd';
        }
        else if(this.days<=56){
          //求星期数
          for(let i=0;i<this.days;i++){
            let week =Math.floor(i/7);
            ts[week] =[];
          }
          //求ts
          let k=0;
          for(let i=0;i<this.days;i++) {
            let week =Math.floor(i/7);//确定属于第几星期
            if(i>0&&(Math.floor(i/7)!==Math.floor((i-1)/7))){
              k=0;
            }
            starDate = new Date(star[0],star[1],star[2]);
            let d =star[2]+i;
            let now = starDate.setDate(d);
            let day = new Date(now).getDay();
            if (No.indexOf(day) === -1) {
              ts[week][k] = [];
              ts[week][k][0] = new Date(now).getTime()/1000;
              starDate = new Date(star[0],star[1],star[2]);
              ts[week][k][1] = new Date(starDate.setDate(d+1)).getTime()/1000;
              k++;
            }
          }
          //获取xDate
          let length1 = ts.length,m=0;
          for(let i=0;i<length1;i++){
            let length2 = ts[i].length;
            if(length2===0){
              ts.splice(i,1);
              continue;
            }
            else{
              let sta = format.formatterDate8(ts[i][0][0]);
              let end ='';
              if(length2>1){
                end = format.formatterDate8(ts[i][length2-1][0]);
              }else{
                end=sta;
              }
              this.xDate[m] = sta+'-'+end;
              m++;
            }
          }
          this.interval = 'w';
        }
        else{
          for(let i=0;i<this.days;i++) {
            //算总共几个月
            starDate = new Date(star[0],star[1],star[2]);
            let d =star[2]+i;
            let m = new Date(starDate.setDate(d)).getMonth();
            let month =m-star[1];
            ts[month] =[];
            starDate = new Date(star[0],star[1],star[2]);
          }
          let k=0;
          for(let i=0;i<this.days;i++) {
            starDate = new Date(star[0],star[1],star[2]);
            let d =star[2]+i;
            let now = starDate.setDate(d);
            let m = new Date(now).getMonth();
            let month =m-star[1];
            starDate = new Date(star[0],star[1],star[2]);
            //判断是否是下一个月
            if(i>0&& new Date(now).getMonth()!==new Date(starDate.setDate(d-1)).getMonth()){
              k=0;
            }
            let day = new Date(now).getDay();
            if (No.indexOf(day) === -1) {
              ts[month][k] = [];
              ts[month][k][0] = new Date(now).getTime()/1000;
              //startDate每次setDate()都会改变自身，因此每使用一次都要初始化
              starDate = new Date(star[0],star[1],star[2]);
              ts[month][k][1] = new Date(starDate.setDate(d+1)).getTime()/1000;
              k++;
            }
          }
          //获取xDate
          let length1 = ts.length,m=0;
          for(let i=0;i<length1;i++){
            let length2 = ts[i].length;
            if(length2===0){
              ts.splice(i,1);
              continue;
            }
            else {
              let sta = format.formatterDate8(ts[i][0][0]);
              let end = '';
              if (length2 > 1) {
                end = format.formatterDate8(ts[i][length2 - 1][0]);
              } else {
                end = sta;
              }
              this.xDate[i] = sta + '-' + end;
            }
          }
          this.interval = 'm';
        }
        //  console.log(ts,this.xDate);
        this.xDate2 = this.xDate;
        return ts;
      },
      printPdf(){
        auth.print_page();
      },
    },
    mounted: function () {
      self.document.title =this.$t('TrendRe');
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isDe = (lang==='de')?true:false;
      this.isIt = (lang==='it')?true:false;
      this.isMg = (localStorage.getItem('unit')==='mg')?true:false;
      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      this.et= parseInt(sessionStorage.getItem('qet4'));
      this.st= parseInt(sessionStorage.getItem('qst4'));
      let days =parseInt((this.et-this.st)/86400)+1;
      if(days<=7){ this.interval='d';}
      else if(days<=56){ this.interval='w';}
      else{ this.interval='m';}
      this.timeRange = format.formatterDate2(this.st)+' - '+format.formatterDate2(this.et);
      this.weekmode = sessionStorage.getItem('qweekMode');
      this.ts = this.getTs2(this,this.st,this.et);
      let param = {
        ts:this.ts,
        interval:this.interval,
        tz:parseInt(sessionStorage.getItem('tz')),
        weekmode:this.weekmode,
        gu:(this.isMg)?'mg/dL':'mmol/L',
      };
      param = B64.base64encode(JSON.stringify(param));
      //this.getStatics(param);
      auth.getTa(this,this.uid,param);
      let first = parseInt(sessionStorage.getItem('qFirst4'));
      if(first===1){
        auth.checkPrint(this,5,4);
      }
    },
  }
</script>

<style scoped meadia="print">
  /*@page{
    *size:auto;
    size:landscape;
    margin: 0;
  }*/
  .background{
    padding-top: 5mm;
    width: 100%;
    *min-height: 337mm;
    background: #ccc;
  }
  .background .noPrint{
    float: left;
    border-radius:100px;
    background: #fff;
    border: 1px solid #a3a3a3;
    outline: none;
    margin-top:4px;
    width:90px;
    height:26px;
    line-height: 28px;
    cursor: pointer;
    margin-left:-140px;
    font-size: 13px;
    text-align: center;
  }
  @media print {
    .background .noPrint{
      display: none;
    }
  }
  .chart-container {
    width:297mm;
    *min-height:337mm;
    font-family:SFUIText-Regular;
    font-size:12px;
    color:#282828;
    letter-spacing:-0.34px;
    background: #fff;
    margin:0 auto;
    padding-left: 20px;
    padding-right: 20px;
  }
  @media screen and (max-width: 1450px){
    .background .noPrint{
      position: absolute;
      left: 20%;
      top: -1px;
    }
    .chart-container{
      margin-top: 20px;
    }
  }
  .Hcp-main-header{
    width:97%;
    height:40px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:12px;
    color:#282828;
    padding-top: 10px;
  }
  .main-header-left{
    float: left;
  }
  .main-header-left img{
    height:45px;
    width: 100px;
  }
  .main-header-right{
    float: right;
    text-align: right;
    padding-top: 10px;
    margin-right: 15px;
  }
  .main-header-right p{
    font-size:12px;
    margin-bottom: 5px;
    letter-spacing:-0.29px;
    font-family:SFUIText-Regular;
    color:#282828;
  }

  .status-table1{
    width: 94%;
    margin:20px auto 16px;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:left;
    table-layout: fixed;
  }
  .status-table1 td{
    padding-left: 10px;
    height:15px;
  }
  .status-table1 .td1{
    width: 14%;
  }
  .zh1 .td1{
    width: 12%;
  }
  .de1 .td1{
    width: 11%;
  }
  .de1 td{
    padding-left: 3px;
  }
  .status-table1 .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .status-table1 .td3{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .status-table1 .td4{
    border-right:1px solid rgba(116,116,116,0.34);
  }

  .small-hr{
    width:94%;
    margin:10px auto 16px;
    border-top:1px solid #3b3b3b;
  }
  .chart-container .graph{
    width:97%;
    height:150px;
    margin-left: 2%;
    margin-bottom: 5px;
  }

  .statics{
    clear: both;
    margin-top: 10px;
    margin-bottom: 55px;
  }
  .statics p{
    font-family:SFUIText-Regular;
    font-size:14px;
    color:#282828;
    letter-spacing:-0.27px;
    margin-left: 4%;
  }
  .statics-table{
    width: 94%;
    margin:10px auto 0;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:center;
  }
  .de2{
    word-wrap: break-word;
    word-break: break-all;
  }
  .statics-table td{
    font-size:8px;
    height:15px;
  }
  .statics-table .td1{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td3{
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .spe-statics{
    margin-bottom: 10px;
  }
  .spe-statics table{
    table-layout: fixed;
  }
  .value_percent_cell {
    display: block;
    float: left;
    width:50%;
  }
  .page-seperator {
    *height:40mm;
    page-break-before: always;
  }
  .page-starter {
    height:10mm;
  }

  .page-end {
    clear:both;
    height:10mm;
  }

</style>



// WEBPACK FOOTER //
// quickPrint4.vue?65289af4